import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "grid shadow-box"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  border: "0",
  style: {
    "width": "100%",
    "text-align": "center"
  }
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString($props.title), 1), _createElementVNode("h3", null, _toDisplayString($props.dataObj.day.count), 1), _createElementVNode("table", _hoisted_3, [_cache[0] || (_cache[0] = _createElementVNode("tr", null, [_createElementVNode("th", null, "本日新增"), _createElementVNode("th", null, "本周新增")], -1)), _createElementVNode("tr", null, [_createElementVNode("td", null, [_createElementVNode("span", null, _toDisplayString($props.dataObj.day.count), 1), _createElementVNode("span", {
    class: _normalizeClass({
      'increment': $props.dataObj.day.inr,
      'nOIncrement': !$props.dataObj.day.inr
    })
  }, [_createTextVNode(" " + _toDisplayString($props.dataObj.day.proportion), 1), $props.dataObj.day.inr ? (_openBlock(), _createElementBlock("span", _hoisted_4, "↑")) : (_openBlock(), _createElementBlock("span", _hoisted_5, "↓"))], 2)]), _createElementVNode("td", null, [_createElementVNode("span", null, _toDisplayString($props.dataObj.week.count), 1), _createElementVNode("span", {
    class: _normalizeClass({
      'increment': $props.dataObj.week.inr,
      'nOIncrement': !$props.dataObj.week.inr
    })
  }, [_createTextVNode(" " + _toDisplayString($props.dataObj.week.proportion), 1), $props.dataObj.week.inr ? (_openBlock(), _createElementBlock("span", _hoisted_6, "↑")) : (_openBlock(), _createElementBlock("span", _hoisted_7, "↓"))], 2)])])])]);
}